import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

export const dialogSm = defineStyle({
  w: "450px",
  maxWidth: "450px",
});

export const dialogMd = defineStyle({
  w: "500px",
  maxWidth: "500px",
});

export const closeButtonMd = defineStyle({
  w: "24px",
  h: "24px",
  fontSize: "16px",
  p: "4px",
  borderRadius: "2px",
});

export const headerMd = defineStyle({
  p: "20px 40px",
  fontSize: "18px",
  fontWeight: "600",
});

export const dialogBodyMd = defineStyle({
  p: "0 40px",
  fontSize: "14px",
});

const sizes = {
  sm: definePartsStyle({ dialog: dialogSm, header: headerMd, body: dialogBodyMd }),
  md: definePartsStyle({ dialog: dialogMd, header: headerMd, body: dialogBodyMd }),
  unset: definePartsStyle({
    dialog: defineStyle({
      maxW: "unset",
    }),
    body: dialogBodyMd,
  }),
};

export const darkStyle = definePartsStyle({
  // define the part you're going to style
  dialog: {
    bg: "bg.panelBg",
    color: "white",
  },
  closeButton: {
    color: "fill.emphasis",
    ...closeButtonMd,
  },
  footer: {
    justifyContent: "center",
  },
});

export const ModalTheme = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    dialog: {
      borderRadius: "12px",
      maxW: "unset",
    },
  }),
  variants: {
    dark: darkStyle,
  },
  sizes: sizes,
  defaultProps: {
    size: "unset",
  },
});
